import ResolveHeaderDesktop from './ResolveHeaderDesktop.component';

export default ResolveHeaderDesktop;
